'use strict';

define(['jquery'], function () {
  var $body = $('body');

  var productFollow = {
    // Config in scope
    config: {},

    /**
     * Initiation function
     * @param config
     */
    init: function init(config) {
      // Check values and set defaults if necessary
      config.productSlide.length ? true : config.productSlide = '', config.win.length ? true : config.win = '', config.variations.length ? true : config.variations = '', config.errorMessage.length ? true : config.errorMessage = '', config.mainButton.length ? true : config.mainButton = '', config.productSlideH ? true : config.productSlideH = 0, config.upsellH ? true : config.upsellH = 0, config.headerH ? true : config.headerH = 0, config.pageContainerH ? true : config.pageContainerH = 0, config.topRailH ? true : config.topRailH = 0, config.betaSiteSwitcherH ? true : config.betaSiteSwitcherH = 0, config.takeoverH ? true : config.takeoverH = 0, config.gutterMargin ? true : config.gutterMargin = 24, config.initiate ? true : config.initiate = true, config.speed ? true : config.speed = {}, config.speed.fadein ? true : config.speed.fadein = 300, config.speed.fadeout ? true : config.speed.fadeout = 150, config.speed.scroll ? true : config.speed.scroll = 800, config.algorithm ? true : config.algorithm = {};
      this.config = config;
      this.checkProductFadeIn(config);
      this.stickyProductClick(config);
      this.validationCheck(config);
    },

    /**
     * Called on window scroll
     * @returns {*}
     */
    windowScroll: function windowScroll() {
      return this.checkProductFadeIn(this.config);
    },

    /**
     * Product Limits
     * @param config
     * @returns {*}
     */
    checkProductFadeIn: function checkProductFadeIn(config) {
      config.algorithm.top = config.win.scrollTop() > config.takeoverH + config.betaSiteSwitcherH + config.headerH + config.topRailH + config.upsellH;
      config.algorithm.bottom = config.win.scrollTop() > config.pageContainerH - config.productSlideH + config.gutterMargin + config.betaSiteSwitcherH;

      if (config.algorithm.bottom) {
        return config.productSlide.removeClass('visible').addClass('stop').css({
          marginTop: config.pageContainerH - config.topRailH - config.upsellH - config.productSlideH - config.gutterMargin - config.takeoverH
        });
      }

      if (config.algorithm.top) {
        if (config.initiate === true) {
          config.productSlide.stop().animate({
            opacity: 1
          }, {
            duration: config.speed.fadein,
            queue: false
          });
          config.initiate = false;
        }
        return config.productSlide.removeClass('stop').addClass('visible').css({
          marginTop: 0
        });
      }

      config.productSlide.stop().animate({
        opacity: 0
      }, {
        duration: config.speed.fadeout,
        complete: function complete() {
          config.productSlide.removeClass('visible');
        }
      });

      config.initiate = true;
    },

    /**
     * Sticky button click event
     * @param config
     */
    stickyProductClick: function stickyProductClick(config) {
      config.productSlide.on('click', function () {
        $body.animate({
          scrollTop: $body.offset().top,
          duration: config.speed.scroll
        });
        if (config.mainButton.hasClass('disabled')) {
          return setTimeout(function () {
            config.errorMessage.fadeIn({
              duration: config.speed.scroll / 2
            });
          }, config.speed.scroll);
        }
        return config.mainButton.click();
      });
    },

    /**
     * Check the product options have been selected
     * @param config
     */
    validationCheck: function validationCheck(config) {
      if (config.variations !== '') {
        config.variations.find('select[name="option"]').change(function () {
          setTimeout(function () {
            if (!config.mainButton.hasClass('disabled')) {
              config.errorMessage.fadeOut({
                duration: config.speed.scroll / 2
              });
            }
          }, config.speed.scroll / 2);
        });
      }
    }
  };

  return productFollow;
});
//# sourceMappingURL=product-follow.js.map
